import Vue from "vue";
import { Button, Toast, Dialog, Field, Popup, Loading, Overlay, Icon, Col, Row, Lazyload, Image as VanImage, Cell, CellGroup, Swipe, SwipeItem } from "vant";
Vue.use(Button);
Vue.use(Toast);
// 将所有 Toast 的展示时长设置为 2000 毫秒
Toast.setDefaultOptions({ duration: 2000 });
// 将所有 loading Toast 设置为背景不可点击
Toast.setDefaultOptions("loading", { forbidClick: true });
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);
Vue.use(Lazyload);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Swipe);
Vue.use(SwipeItem);
